import { Component, Shark } from "shark-mvc";

import templateContent from "./related-links.html";

class RelatedLinksComponent extends Component {
	constructor () {
		super("relatedLinksComponent");

		this.addTemplate("", templateContent);
	}

	addRelatedLinkBtn_clickHandler () {
		this.addRelatedLinkToCurrContent();
	}

	addRelatedLinkToCurrContent () {
		const { currContent } = Shark.get();
		
		if (currContent) {
			let linkURL = Shark.$store.relatedLinksData.linkURL.trim().toLowerCase();

			if (linkURL === "") {
				alert("Non puoi inserire un Link senza impostare un indirizzo!");
				return;
			}

			if (Shark.$store.relatedLinksData.linkTitle === "" && !confirm("Vuoi davvero inserire un Link senza impostare un Titolo?")) {
				return;
			}

			if (linkURL.slice(0, 4) === "http") {
				linkURL = linkURL.slice(linkURL.indexOf("://") + 3);
			}

			const newUrl = {
				internal: false,
				title: Shark.$store.relatedLinksData.linkTitle || "(titolo non impostato)",
				url: Shark.$store.relatedLinksData.__linkProtocol + linkURL,
			};

			const relatedLinks = [...currContent.relatedLinks, newUrl];

			relatedLinks.forEach((item, index) => item.__index = index);

			currContent.set({
				relatedLinks,
			});

			this.resetRelatedLinkField();

			Shark.render();
		}
	}

	
	deleteAllRelatedLinks () {
		if (confirm(`Vuoi davvero cancellare tutti i Link associati a "${Shark.$store.currContent.title}"`)) {
			Shark.$store.currContent.set({
				relatedLinks: [],
			});
			Shark.render();
		}
	}
	
	deleteAllRelatedLinksBtn_clickHandler () {
		this.deleteAllRelatedLinks();
	}


	deleteRelatedLink (index) {
		const { currContent } = Shark.get();

		if (currContent && confirm(`Sei sicuro di voler eliminare il link "${currContent.relatedLinks[index].url}" da "${Shark.$store.currContent.title}"`)) {
			const relatedLinks = [...currContent.relatedLinks];
			relatedLinks.splice(index, 1);
			relatedLinks.forEach((item, index) => item.__index = index);

			currContent.set({
				relatedLinks,
			});
			Shark.render();
		}
	}

	deleteRelatedLinkBtn_clickHandler (event, data) {
		if (data.index !== undefined) {
			this.deleteRelatedLink(data.index);
		}
	}

	init () {
		const relatedLinksData = Shark.getInstance("__smart__", {
			linkURL: "",
			linkTitle: "",
			__linkProtocol: "https://",
		});

		Shark.set({
			relatedLinksData,
			searchResultImageContentList: [],
			searchResultPlaceContentList: [],
		});
	}

	relatedLinkURLField_keyupHandler (event) {
		if (event.keyCode === 13) {
			this.addRelatedLinkToCurrContent();
		}
	}

	relatedLinkTitleField_keyupHandler (event) {
		if (event.keyCode === 13) {
			this.addRelatedLinkToCurrContent();
		}
	}

	resetRelatedLinkField () {
		Shark.$store.relatedLinksData.set({
			linkURL: "",
			linkTitle: "",
		});
	}

	resetRelatedLinkFieldBtn_clickHandler () {
		this.resetRelatedLinkField();
	}
}

const relatedLinksComponent = new RelatedLinksComponent();

Shark.registerComponent(relatedLinksComponent);

export default relatedLinksComponent;
